var _circle, _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 54,
    r: 47,
    fill: "#8ECDD6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_3163_22737)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 54.0002,
    cy: 54,
    r: 39,
    fill: "#73A6AD"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5738 40.6659C38.7748 40.6659 37.3152 42.1107 37.3152 43.8916C37.3152 44.9064 37.7972 45.8606 38.6186 46.4722L53.3911 57.4396C54.165 58.0108 55.2241 58.0108 55.998 57.4396L70.7705 46.4722C71.5919 45.8606 72.0739 44.9064 72.0739 43.8916C72.0739 42.1107 70.6143 40.6659 68.8153 40.6659H40.5738ZM37.3152 48.1926V62.1707C37.3152 64.5429 39.2636 66.4716 41.66 66.4716H67.7291C70.1255 66.4716 72.0739 64.5429 72.0739 62.1707V48.1926L57.3015 59.16C55.7536 60.3092 53.6355 60.3092 52.0876 59.16L37.3152 48.1926Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3163_22737",
    x: 0.000244141,
    y: 0,
    width: 108,
    height: 108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "effect1_foregroundBlur_3163_22737"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.125bd0eb7a5b55b5c8bf3cb3ae2a7064.svg";
export { ForwardRef as ReactComponent };